module.exports = __webpack_public_path__ + "static/media/Barmag 7b3.51b45d5d.jpg";